// extracted by mini-css-extract-plugin
export var bodyFooterButtonFull = "WebQuoteForm-module--body-footer-button-full--8da76";
export var bodyFooterButtonHalf = "WebQuoteForm-module--body-footer-button-half--ee8b2";
export var extraFieldsContainer = "WebQuoteForm-module--extra-fields-container--e558e";
export var footer = "WebQuoteForm-module--footer--aca2d";
export var form = "WebQuoteForm-module--form--8cf58";
export var requiredFieldsLabel = "WebQuoteForm-module--required-fields-label--ee6ab";